import { environment } from '@quartz-gov-legacy/environments/environment';

(function () {
    'use strict';

    angular
        .module('recomModule')
        .factory('recomService', service);

    service.$inject = ['$http'];

    function service($http) {
        var baseUrl = environment.apiUrl + '/Pilot/api/Recom';

        return {
            getAvailableBusinessUnits: function () {
                return $http
                    .get(baseUrl + '/BusinessUnit')
                    .then(function(response) {return response.data;});
            },
            getBusinessUnitByCode: function (businessUnitCode) {
                return $http
                    .get(baseUrl + '/BusinessUnit/' + businessUnitCode)
                    .then(function (response) { return response.data });
            },
            getObservationsByCampaign: function (campaignId) {
                return $http
                    .get(baseUrl + '/For/Campaign/' + campaignId + '/Observation')
                    .then(function (response) { return response.data; })
            },


            // ==== Governance Process ====

            // Create
            createGovernanceProcess: function (governanceProcess) {
                return $http
                    .post(baseUrl + '/GovernanceProcess', {governanceProcess})
                    .then(function (response) { return response.data; })
            },
            // Update
            updateGovernanceProcess: function (governanceProcess) {
                return $http
                    .put(baseUrl + '/GovernanceProcess/' + governanceProcess.GovernanceProcessID, {governanceProcess})
                    .then(function (response) { return response.data; })
            },

            // ValidateActionPlans
            validateBusinessUnit: function (businessUnitId) {
                return $http
                    .get(baseUrl + '/BusinessUnit/' + businessUnitId + '/Validate')
                    .then(function (response) { return response.data; })
            },
            // Get Active by Business Unit
            getActiveGovernanceProcessByRecomBusinessUnit: function (businessUnitId) {
                return $http
                    .get(baseUrl + '/GovernanceProcess/' + businessUnitId + '/Active')
                    .then(function(response) {return response.data;});
            },

            // ==== LookUps ====
            getLookups: function () {
                var reqUrl = baseUrl + '/Lookup';

                return $http
                        .get(reqUrl, {cache : true})
                        .then(function (response) { return response.data; });
            },
        }
    }
})();
